


































































import Vue from "vue";

export default Vue.extend({
  name: "Pipeline",
  data() {
    return {
      screenWidth: <any>null,
      content: [
        {
          code: "DF-006",
          name: "Drug1",
          indication: "Hepatitis B",
          stage: "progress-four",
        },
        {
          code: "DF-006",
          name: "Drug2",
          indication: "Liver Disease",
          stage: "progress-four",
        },
        {
          code: "DF-003",
          name: "Drug3",
          indication: "Rare Blindness",
          stage: "progress-three",
        },
        {
          code: "DF-003",
          name: "Drug4",
          indication: "Inflammatory Diseases",
          stage: "progress-three",
        },
        {
          code: "DF-004",
          name: "Drug5",
          indication: "Colitis",
          stage: "progress-two",
        },
        {
          code: "DF-005",
          name: "Drug6",
          indication: "Atherosclerosis",
          stage: "progress-two",
        },
        {
          code: "DF-007",
          name: "Drug7",
          indication: "Cancer",
          stage: "progress-two",
        },
		{
          code: "DF-X1",
          name: "Drug8",
          indication: "Colitis",
          stage: "progress-one",
        },
      ],
    };
  },
  created() {
    this.setScreenWidth();
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$nextTick(() => this.setProgressBar());
    window.addEventListener("resize", () => {
      this.setScreenWidth();
      this.setProgressBar();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.setScreenWidth();
      this.setProgressBar();
    });
  },
  methods: {
    setScreenWidth() {
      this.screenWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    },
    setProgressBar() {
      const progressBar: any = this.$refs.progress;
      if (this.screenWidth > 999 || !progressBar) return;

      const headers = {
        headOne: this.$refs.headOne,
        headTwo: this.$refs.headTwo,
        headThree: this.$refs.headThree,
        headFour: this.$refs.headFour,
        headFive: this.$refs.headFive,
      };
      const headersWidth: any = this.getHeadersWidth(headers);

      progressBar.forEach((bar: any) => {
        const fillClass = bar.classList[0];
        this.setAllProgressBackground(bar, fillClass, headersWidth);
      });
    },
    setAllProgressBackground(bar: any, fillClass: string, headersWidth: any) {
      switch (fillClass) {
        case "progress-one":
          const onePrecentageP1 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth,
            headersWidth.total
          );
          this.setProgressBackground(
            bar,
            fillClass,
            onePrecentageP1,
            onePrecentageP1
          );

          return;
        case "progress-two":
          const onePrecentageP2 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth,
            headersWidth.total
          );
          const twoPrecentageP2 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth + headersWidth.headTwoWidth + 5,
            headersWidth.total
          );
          this.setProgressBackground(
            bar,
            fillClass,
            onePrecentageP2,
            twoPrecentageP2
          );

          return;
        case "progress-three":
          const onePrecentageP3 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth + headersWidth.headTwoWidth,
            headersWidth.total
          );
          const twoPrecentageP3 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth +
              headersWidth.headTwoWidth +
              headersWidth.headThreeWidth +
              10,
            headersWidth.total
          );
          this.setProgressBackground(
            bar,
            fillClass,
            onePrecentageP3,
            twoPrecentageP3
          );

          return;
        case "progress-four":
          const onePrecentageP4 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth + 
              headersWidth.headTwoWidth +
              headersWidth.headThreeWidth,
            headersWidth.total
          );
          const twoPrecentageP4 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth +
              headersWidth.headTwoWidth +
              headersWidth.headThreeWidth +
              headersWidth.headFourWidth +
              15,
            headersWidth.total
          );
          this.setProgressBackground(
            bar,
            fillClass,
            onePrecentageP4,
            twoPrecentageP4
          );

          return;
        case "progress-five":
          const onePrecentageP5 = this.getProgressWidthPrecentage(
            headersWidth.headOneWidth +
              headersWidth.headTwoWidth +
              headersWidth.headThreeWidth +
              headersWidth.headFourWidth,
            headersWidth.total
          );
          this.setProgressBackground(bar, fillClass, onePrecentageP5, 100);

          return;
        default:
          return;
      }
    },
    setProgressBackground(
      bar: any,
      barClass: string,
      precentageP1: number,
      precentageP2?: number
    ) {
      if (barClass === "progress-one") {
        bar.style.background = `linear-gradient(to right, #84e4ff ${precentageP1}%, #f1f1f1 ${precentageP1}%)`;
      } else {
        bar.style.background = `linear-gradient(to right, #00b3e6 ${precentageP1}%, #84e4ff ${precentageP2}%, #f1f1f1 ${precentageP2}%)`;
      }
    },
    getProgressWidthPrecentage(headWidth: number, headTotal: number) {
      return (headWidth / headTotal) * 100;
    },
    getHeadersWidth(headers: any) {
      const invalidHeaders = Object.keys(headers).some(
        (key: string) => !headers[key] || !headers[key].length
      );
      if (invalidHeaders) return;

      const headersWidth = {
        headOneWidth: this.getOffsetWidth(headers, "headOne"),
        headTwoWidth: this.getOffsetWidth(headers, "headTwo"),
        headThreeWidth: this.getOffsetWidth(headers, "headThree"),
        headFourWidth: this.getOffsetWidth(headers, "headFour"),
        headFiveWidth: this.getOffsetWidth(headers, "headFive"),
      };
      return {
        ...headersWidth,
        total:
          headersWidth.headOneWidth +
          headersWidth.headTwoWidth +
          headersWidth.headThreeWidth +
          headersWidth.headFourWidth +
          headersWidth.headFiveWidth
      };
    },
    getOffsetWidth(item: any, path: string) {
      const width = item[path][0].offsetWidth;
      return typeof width === "number" ? width : 0;
    },
  },
});
